"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BarLoader_1 = __importDefault(require("./BarLoader"));
var BeatLoader_1 = __importDefault(require("./BeatLoader"));
var BounceLoader_1 = __importDefault(require("./BounceLoader"));
var CircleLoader_1 = __importDefault(require("./CircleLoader"));
var ClimbingBoxLoader_1 = __importDefault(require("./ClimbingBoxLoader"));
var ClipLoader_1 = __importDefault(require("./ClipLoader"));
var ClockLoader_1 = __importDefault(require("./ClockLoader"));
var DotLoader_1 = __importDefault(require("./DotLoader"));
var FadeLoader_1 = __importDefault(require("./FadeLoader"));
var GridLoader_1 = __importDefault(require("./GridLoader"));
var HashLoader_1 = __importDefault(require("./HashLoader"));
var MoonLoader_1 = __importDefault(require("./MoonLoader"));
var PacmanLoader_1 = __importDefault(require("./PacmanLoader"));
var PropagateLoader_1 = __importDefault(require("./PropagateLoader"));
var PulseLoader_1 = __importDefault(require("./PulseLoader"));
var PuffLoader_1 = __importDefault(require("./PuffLoader"));
var RingLoader_1 = __importDefault(require("./RingLoader"));
var RiseLoader_1 = __importDefault(require("./RiseLoader"));
var RotateLoader_1 = __importDefault(require("./RotateLoader"));
var ScaleLoader_1 = __importDefault(require("./ScaleLoader"));
var SkewLoader_1 = __importDefault(require("./SkewLoader"));
var SquareLoader_1 = __importDefault(require("./SquareLoader"));
var SyncLoader_1 = __importDefault(require("./SyncLoader"));
exports.BarLoader = BarLoader_1.default;
exports.BeatLoader = BeatLoader_1.default;
exports.BounceLoader = BounceLoader_1.default;
exports.CircleLoader = CircleLoader_1.default;
exports.ClimbingBoxLoader = ClimbingBoxLoader_1.default;
exports.ClipLoader = ClipLoader_1.default;
exports.ClockLoader = ClockLoader_1.default;
exports.DotLoader = DotLoader_1.default;
exports.FadeLoader = FadeLoader_1.default;
exports.GridLoader = GridLoader_1.default;
exports.HashLoader = HashLoader_1.default;
exports.MoonLoader = MoonLoader_1.default;
exports.PacmanLoader = PacmanLoader_1.default;
exports.PropagateLoader = PropagateLoader_1.default;
exports.PulseLoader = PulseLoader_1.default;
exports.PuffLoader = PuffLoader_1.default;
exports.RingLoader = RingLoader_1.default;
exports.RiseLoader = RiseLoader_1.default;
exports.RotateLoader = RotateLoader_1.default;
exports.ScaleLoader = ScaleLoader_1.default;
exports.SkewLoader = SkewLoader_1.default;
exports.SquareLoader = SquareLoader_1.default;
exports.SyncLoader = SyncLoader_1.default;
